/**
 * Route for `publisher-invoicing-day-wise-or-campaign-wise`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PublisherInvoicingDayWiseOrCampaignWisePage } from "../features/publisher-invoicing-day-wise-or-campaign-wise/PublisherInvoicingDayWiseOrCampaignWisePage";

export const publisherInvoicingDayWiseOrCampaignWiseRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/publisher-invoicing-day-wise-or-campaign-wise",
	component: PublisherInvoicingDayWiseOrCampaignWisePage,
});

export default publisherInvoicingDayWiseOrCampaignWiseRoute;
